import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autoclick"
export default class extends Controller {
  static targets = ['link']
  connect() {
    this.linkTarget.click();
  }
}
